import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { IMissingDataTableItem } from './types';
import { cpfMask } from "utils/cpf";
import dayjs from "dayjs";

type Props = {
  data: IMissingDataTableItem[];
}

export function TableView({ data }: Props) {
  const realColumns: GridColDef<(typeof realRows)[number]>[] = [
    { field: "name", headerName: "Nome", width: 250 },
    { field: "taxPayerId", headerName: "CPF", width: 150 },
    { field: "personType", headerName: "Tipo", width: 120 },
    { field: "employeeTaxPayerId", headerName: "CPF Titular", width: 150 },
    { field: "birthDate", headerName: "Data Nascimento", width: 150 },
    { field: "motherName", headerName: "Nome da Mãe", width: 200 },
    { field: "maritalStatusId", headerName: "Estado Civil", width: 150 },
    { field: "genderId", headerName: "Gênero", width: 120 },
    { field: "address", headerName: "Endereço", width: 250 },
    { field: "addressNumber", headerName: "Número", width: 100 },
    { field: "addressType", headerName: "Tipo Endereço", width: 150 },
    { field: "complement", headerName: "Complemento", width: 180 },
    { field: "neighborhood", headerName: "Bairro", width: 180 },
    { field: "zipCode", headerName: "CEP", width: 120 },
    { field: "registrationNumber", headerName: "RG", width: 150 },
    { field: "hiringDate", headerName: "Data Admissão", width: 150 },
    { field: "dependentTypeId", headerName: "Tipo Dependente", width: 150 },
    { field: "isStudent", headerName: "É Estudante", width: 120 },
    { field: "updatedAt", headerName: "Data Atualização", width: 180 },
  ];

  const realRows = data.map((row, index) => {
    // Safe date formatting function
    const formatDate = (date: any, format: string = "DD/MM/YYYY") => {
      if (!date) return '-';
      try {
        const parsedDate = dayjs(date);
        return parsedDate.isValid() ? parsedDate.format(format) : '-';
      } catch {
        return '-';
      }
    };

    // Safe CPF masking function
    const safeCpfMask = (cpf: any) => {
      if (!cpf || typeof cpf !== 'string') return '-';
      try {
        return cpfMask(cpf);
      } catch {
        return cpf; // Return original if mask fails
      }
    };

    return {
      id: index + 1,
      name: row?.name ?? '-',
      taxPayerId: safeCpfMask(row?.taxPayerId),
      personType: row?.personType === 'employee' ? 'Titular' : 'Dependente',
      employeeTaxPayerId: safeCpfMask(row?.employeeTaxPayerId),
      birthDate: formatDate(row?.birthDate),
      motherName: row?.motherName ?? '-',
      maritalStatusId: row?.maritalStatusId ?? '-',
      genderId: row?.genderId ?? '-',
      address: row?.address ?? '-',
      addressNumber: row?.addressNumber ?? '-',
      addressType: row?.addressType ?? '-',
      complement: row?.complement ?? '-',
      neighborhood: row?.neighborhood ?? '-',
      zipCode: row?.zipCode ?? '-',
      registrationNumber: row?.registrationNumber ?? '-',
      hiringDate: formatDate(row?.hiringDate),
      dependentTypeId: row?.dependentTypeId ?? '-',
      isStudent: row?.isStudent ?? '-',
      updatedAt: formatDate(row?.updatedAt, "DD/MM/YYYY HH:mm"),
    };
  });

  return (
    <DataGrid
      rows={realRows}
      columns={realColumns}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
      pageSizeOptions={[10, 25, 50, 100]}
      disableRowSelectionOnClick
      style={{ backgroundColor: "white", minHeight: 400 }}
      localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
      // autoHeight
    />
  )
}